/**
 * A List with slide-in detail panel.
 */
import * as React from 'react';

import 'css!./__styles__/Navigation';

type NavigationViewProps = {
  className?: string;
};

export class NavigationView extends React.LegacyComponentWithChildren<NavigationViewProps> {
  render() {
    const { children, className } = this.props;
    return <div className={`c-Navigation-View h-100 ${className}`}>{children}</div>;
  }
}

type Props = {
  /**
   * zero-based current screen index
   */
  index: number;

  /**
   * Requires at least two Views
   */
  children: Array<React.ReactNode>;

  className?: string;
};

export class Navigation extends React.LegacyComponentWithChildren<Props> {
  render() {
    const { index, children, className } = this.props;

    const style = {
      // for each screen, width = 100% content + 10px margin-right
      width: `calc(${children.length * 100}% + ${children.length * 10}px)`,
      transform: `translateX(${(-100 / children.length) * index}%)`,
    };

    return (
      <div className={`rc-Navigation ${className}`}>
        <div className="c-Navigation-wrapper h-100" style={style}>
          {children}
        </div>
      </div>
    );
  }
}
